import httpClient from './httpClient';
import { isNotFoundError } from './apiError';

const configuracoesService = {
  salvarConfiguracoes(email, configuracoes) {
    return httpClient.post('/user/configuracoes', { email, configuracoes }, {
      operation: 'configuracoes.salvar',
    });
  },

  async carregarConfiguracoes(email) {
    try {
      return await httpClient.get(`/user/configuracoes/${encodeURIComponent(email)}`, {
        operation: 'configuracoes.carregar',
      });
    } catch (error) {
      if (isNotFoundError(error)) return { success: false, configuracoes: null };
      throw error;
    }
  },
};

export { configuracoesService };
export default configuracoesService;
